var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "testSingle", staticClass: "testSingle" },
    [
      _vm.eidtTaskFlag
        ? _c("div", {
            staticClass: "icon-util list-radio-position",
            class: _vm.$store.state.taskListSelectedArr.includes(_vm.item)
              ? "task-list-radio-check"
              : "task-list-radio"
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "threadParents",
          class: [
            _vm.eidtTaskFlag ? "task-list-edit-box" : "task-list-box",
            _vm.collapseFlage == _vm.index &&
            _vm.detailShow &&
            !_vm.item.sources &&
            (_vm.item.type == 1 || _vm.item.type == 6)
              ? "task-list-collapse-box"
              : "",
            _vm.collapseFlage == _vm.index &&
            _vm.detailShow &&
            _vm.item.type == 2
              ? "singletask-collapse-box"
              : ""
          ],
          style: { height: _vm.getSingleHeight() ? _vm.getSingleHeight() : "" }
        },
        [
          _c("div", { staticClass: "task-list-back" }, [
            _vm.showBackGround(_vm.item)
              ? _c("div", {
                  class: _vm.item.percent ? "task-list-backgroud" : "",
                  style: { width: _vm.item.percent + "%" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.item.avgpercent
              ? _c("div", {
                  class: _vm.item.avgpercent ? "task-list-backgroud" : "",
                  style: { width: _vm.item.avgpercent + "%" }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-lists-info" }, [
            _c("div", { staticClass: "transfer-type" }, [
              _c("div", {
                staticClass: "task-type-icon task-lists-position",
                class: [
                  _vm.item.type == 1 && _vm.item.options.way == "cloudEmail"
                    ? "task-lists-email-transfer"
                    : _vm.item.branchType == "businessTransfer"
                    ? "task-lists-business"
                    : "",
                  _vm.item.type == 1 &&
                  _vm.item.branchType != "share" &&
                  _vm.item.branchType != "businessTransfer"
                    ? "task-lists-transfer"
                    : "",
                  _vm.item.type == 1 && _vm.item.branchType == "share"
                    ? "task-lists-share"
                    : "",
                  _vm.item.type == 2 ? "task-lists-sync" : "",
                  _vm.item.type == 6 ? "task-lists-backup" : ""
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    _vm.item.type == 6 ||
                    _vm.item.branchType == "businessTransfer"
                      ? "task-order-backup"
                      : "task-order"
                  ]
                },
                [
                  _vm._v(
                    "\n          00" +
                      _vm._s(_vm.tasklistData.length - _vm.index)
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-information" }, [
              _c("div", { staticClass: "tasks-type" }, [
                _c("div", { staticClass: "tasks-type" }, [
                  _c("div", { attrs: { title: this.taskUpTxt } }, [
                    _c("span", { staticClass: "list-title-name" }, [
                      _vm._v(_vm._s(this.taskUpTxt) + ":")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "listDriveName",
                      staticClass: "task-list-name",
                      attrs: { title: _vm.item.name },
                      on: {
                        click: function($event) {
                          return _vm.editTaskListName(_vm.index, _vm.item)
                        },
                        mouseenter: function($event) {
                          _vm.hoverCurrent = _vm.index
                        },
                        mouseleave: function($event) {
                          _vm.hoverCurrent = -1
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "tasks-lists-name" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.item.name) +
                            "\n\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.hoverCurrent == _vm.index
                        ? _c("div", {
                            staticClass:
                              "icon-util edit-small edit-small-position"
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      ref: "listInputName",
                      staticClass: "list-outclass",
                      on: {
                        mouseover: function($event) {
                          $event.stopPropagation()
                          _vm.hoverCurrent = -1
                        },
                        click: function($event) {
                          $event.stopPropagation()
                          ;(_vm.hoverCurrent = -1), (_vm.clickCurrent = -1)
                        }
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.inputValue,
                            expression: "item.inputValue"
                          }
                        ],
                        staticClass: "list-task-edit",
                        domProps: { value: _vm.item.inputValue },
                        on: {
                          focus: function($event) {
                            _vm.isflage = true
                          },
                          blur: function($event) {
                            return _vm.submitTaskListName(_vm.item, _vm.index)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "inputValue",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tasks-edit-name" }, [
                        _c("i", {
                          staticClass: "icon-util name-sure",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.submitTaskListName(_vm.item, _vm.index)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "icon-util name-cancel ",
                          on: {
                            mousedown: function($event) {
                              $event.stopPropagation()
                              return _vm.cancelEditDriveName(
                                _vm.index,
                                _vm.item
                              )
                            }
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.type == 1 || _vm.item.type == 6,
                      expression: "item.type == 1||item.type == 6"
                    }
                  ],
                  staticClass: "tasks-destion"
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        width: "100%",
                        display: "flex"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.item.type == 1,
                              expression: "item.type == 1"
                            }
                          ],
                          staticClass: "transfers-from",
                          attrs: { id: "transferFrom" }
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.$i18n.locale != "japanese",
                                  expression: "$i18n.locale!='japanese'"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.common.from")) + ":"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.$i18n.locale == "japanese",
                                  expression: "$i18n.locale=='japanese'"
                                }
                              ]
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.cloudTransfer.from")) +
                                  ":"
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.item.type == 6
                        ? _c("div", { staticClass: "transfers-from" }, [
                            (_vm.item.tranferWay == "restore" ||
                              _vm.item.tranferWay == "retry-restore") &&
                            (_vm.item.status == "Running" ||
                              _vm.item.status == "Waiting")
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("language.cloudBackup.restore")
                                    ) + ":"
                                  )
                                ])
                              : _c("span", [
                                  _vm.$i18n.locale == "japanese"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "language.cloudTransfer.cloudBackupFrom"
                                              )
                                            ) +
                                            ":\n                "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "language.cloudBackup.backup"
                                              )
                                            ) +
                                            ":\n                "
                                        )
                                      ])
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.type != 6 &&
                      _vm.item.branchType != "share" &&
                      !_vm.item.sources
                        ? _c(
                            "div",
                            {
                              staticClass: "list-node-name",
                              style: { width: _vm.getFromWidth },
                              attrs: {
                                title: _vm._f("getCatalogTitle")(
                                  _vm._f("getCatalog")(_vm.item.fromItem.nodes)
                                )
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.toSourceCatalog(_vm.item.fromItem)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("getCatalog")(
                                      _vm.item.fromItem.nodes
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.type == 6
                        ? _c("div", { staticClass: "list-node-name" }, [
                            (_vm.item.tranferWay == "restore" ||
                              _vm.item.tranferWay == "retry-restore") &&
                            (_vm.item.status == "Running" ||
                              _vm.item.status == "Waiting")
                              ? _c("span", [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm._f("getCatalogTitle")(
                                          _vm._f("getCatalog")(
                                            _vm.item.fromItem.nodes
                                          )
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toRestoreSource(_vm.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm._f("getCatalog")(
                                              _vm.item.fromItem.nodes
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ])
                              : _c("span", [
                                  !_vm.item.fromItem.data
                                    ? _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: _vm._f("getCatalogTitle")(
                                              _vm._f("getCatalog")(
                                                _vm.item.fromItem.nodes
                                              )
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toSourceCatalog(
                                                _vm.item.fromItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("getCatalog")(
                                                  _vm.item.fromItem.nodes
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.fromItem.data &&
                                  _vm.item.fromItem.data.length
                                    ? _c(
                                        "span",
                                        {
                                          attrs: {
                                            title: _vm._f("getBackupInfo")(
                                              _vm._f("getCatalog")(
                                                _vm.item.fromItem.data[0].nodes
                                              )
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openBackupSource(
                                                _vm.item.fromItem
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("getBackupInfo")(
                                                  _vm._f("getCatalog")(
                                                    _vm.item.fromItem.data[0]
                                                      .nodes
                                                  )
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.branchType == "share" && !_vm.item.sources
                        ? _c(
                            "div",
                            {
                              staticClass: "list-node-name",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.toSharelicLink(_vm.item)
                                }
                              }
                            },
                            [
                              _vm.item.fromItem.sharePath
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm._f("getCatalog")(
                                          JSON.parse(
                                            _vm.item.fromItem.sharePath
                                          )
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("ellipsis")(
                                            _vm._f("getCatalog")(
                                              JSON.parse(
                                                _vm.item.fromItem.sharePath
                                              )
                                            )
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm._f("getCatalogTitle")(
                                          _vm.item.fromItem.name
                                        )
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.item.fromItem.name))]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.sources &&
                      _vm.item.branchType != "businessTransfer"
                        ? _c("task-list-select", {
                            ref: "taskListSelect",
                            attrs: {
                              type: _vm.item.type,
                              clickDialogCurrent: _vm.clickCurrent,
                              item: _vm.item,
                              index: _vm.index,
                              itemSource: _vm.getMultiSourceCatalog(_vm.item)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.sources &&
                      _vm.item.branchType == "businessTransfer"
                        ? _c(
                            "div",
                            {
                              staticClass: "list-node-name",
                              attrs: {
                                title: _vm._f("getCatalogTitle")(
                                  _vm._f("getCatalog")(_vm.item.toItem.nodes)
                                )
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.toSourceCatalog(
                                    _vm.item.fromItem,
                                    "businessTransfer"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("getBusinessTransferCatalog")(
                                      _vm.item.fromItem.nodes
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.item.type == 2
                ? _c("div", { staticClass: "tasks-destion" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          float: "left",
                          width: "100%",
                          display: "flex"
                        }
                      },
                      [
                        _c("div", { staticClass: "transfers-from" }, [
                          _vm._v(_vm._s(_vm.$t("language.common.from")) + ":")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "list-node-name",
                            attrs: {
                              title: _vm._f("getCatalogTitle")(
                                _vm._f("getCatalog")(_vm.item.fromItem.nodes)
                              )
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toSyncSourceCatalog(
                                  _vm.item.fromItem
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("getCatalog")(_vm.item.fromItem.nodes)
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item &&
              _vm.item.schedules &&
              _vm.item.schedules.type != "Now" &&
              _vm.item.branchType != "realtime"
                ? _c("div", { staticClass: "tasks-shedule" }, [
                    _c("div", [
                      !_vm.item.updateFlag
                        ? _c("div", {
                            staticClass: "icon-util  task-shedule-position",
                            class: !_vm.item.schedules.disabled
                              ? "check-small"
                              : "nocheck-small-blue",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.changeSchedulesStatus(
                                  _vm.item,
                                  _vm.index
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.updateFlag
                        ? _c("div", {
                            staticClass: "icon-util  task-shedule-position",
                            class: !_vm.item.schedules.disabled
                              ? "nocheck-small-disable"
                              : "check-small-disable"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("language.taskList.scheduled")))
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-information-to" }, [
              _c(
                "div",
                { staticClass: "tasks-to-destion" },
                [
                  _vm.item.type == 1 || _vm.item.type == 6
                    ? _c("div", { staticClass: "transfers-from" }, [
                        _vm.$i18n.locale != "japanese"
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("language.common.to")) + ":")
                            ])
                          : _c("span", [
                              _vm.item.type == 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.cloudTransfer.to")
                                      ) + ":"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.item.type == 6
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.cloudTransfer.cloudBackupto"
                                        )
                                      ) + ":"
                                    )
                                  ])
                                : _vm._e()
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.type == 2 || _vm.item.branch == "realtime"
                    ? _c("div", { staticClass: "transfers-from" }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.common.with")) +
                            ":\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.type == 6
                    ? _c("span", [
                        (_vm.item.tranferWay == "restore" ||
                          _vm.item.tranferWay == "retry-restore") &&
                        (_vm.item.status == "Running" ||
                          _vm.item.status == "Waiting")
                          ? _c("span", [
                              _vm.item.toItem.data &&
                              _vm.item.toItem.data.length
                                ? _c("div", [
                                    _vm.item.toItem.isRestoreNew
                                      ? _c(
                                          "div",
                                          {
                                            attrs: {
                                              title: _vm._f("getBackupInfo")(
                                                _vm._f("getCatalog")(
                                                  _vm.item.toItem.data[0].nodes
                                                )
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openBackupToItems(
                                                  _vm.item.toItem
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("getBackupInfo")(
                                                    _vm._f("getCatalog")(
                                                      _vm.item.toItem.data[0]
                                                        .nodes
                                                    )
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "list-node-name",
                                            on: {
                                              click: function($event) {
                                                return _vm.openBackupToItems(
                                                  _vm.item.toItem
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Original")]
                                        )
                                  ])
                                : _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "list-node-name",
                                        on: {
                                          click: function($event) {
                                            return _vm.toAimCatalog(
                                              _vm.item.toItem
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Original\n                "
                                        )
                                      ]
                                    )
                                  ])
                            ])
                          : _c("span", [
                              _vm.item.toItem.data &&
                              _vm.item.toItem.data.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "list-node-name",
                                      attrs: {
                                        title: _vm._f("getBackupInfo")(
                                          _vm._f("getCatalog")(
                                            _vm.item.toItem.data[0].nodes
                                          )
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openBackupSource(
                                            _vm.item.toItem
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("getBackupInfo")(
                                              _vm._f("getCatalog")(
                                                _vm.item.toItem.data[0].nodes
                                              )
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.item.toItem.data
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "list-node-name",
                                      attrs: {
                                        title: _vm._f("getCatalogTitle")(
                                          _vm._f("getCatalog")(
                                            _vm.item.toItem.nodes
                                          )
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.toAimCatalog(
                                            _vm.item.toItem
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("getCatalog")(
                                              _vm.item.toItem.nodes
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (!_vm.item.sources ||
                    (_vm.item.type == 1 &&
                      _vm.item.branchType != "businessTransfer")) &&
                  _vm.item.type != 6 &&
                  _vm.item.toItem
                    ? _c(
                        "div",
                        {
                          staticClass: "list-node-name team-aims",
                          attrs: {
                            title: _vm._f("getCatalogTitle")(
                              _vm._f("getCatalog")(_vm.item.toItem.nodes)
                            )
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toAimCatalog(_vm.item.toItem)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("getCatalog")(_vm.item.toItem.nodes)
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.sources && _vm.item.type == 2
                    ? _c("task-list-select", {
                        ref: "taskListSelect",
                        attrs: {
                          type: 2,
                          clickDialogCurrent: _vm.clickCurrent,
                          item: _vm.item,
                          index: _vm.index,
                          itemSource: _vm.getMultiAimsCatalog(_vm.item)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.sources && _vm.item.branchType == "businessTransfer"
                    ? _c(
                        "div",
                        {
                          staticClass: "list-node-name team-aims",
                          attrs: {
                            title: _vm._f("getBusinessTransferCatalog")(
                              _vm.item.toItem.nodes
                            )
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toAimCatalog(
                                _vm.item.toItem,
                                "businessTransfer"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._f("getBusinessTransferCatalog")(
                                  _vm.item.toItem.nodes
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  _vm.eidtTaskFlag
                    ? "transfer-edit-operating"
                    : "transfer-operating"
                ]
              },
              [
                _c("div", { staticClass: "transfer-operate" }, [
                  _vm.showtasklistMenuOpen(_vm.item)
                    ? _c(
                        "div",
                        {
                          staticClass: "icon-util  task-operating-menu",
                          class: [
                            _vm.item.updateFlag
                              ? "task-list-menu-update"
                              : "task-list-menu"
                          ],
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.tasklistMenuOpen(_vm.index)
                            }
                          }
                        },
                        [
                          _vm.operateMenuIndex == _vm.index
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "clickoutside",
                                      rawName: "v-clickoutside",
                                      value: _vm.tasklistMenuClose,
                                      expression: "tasklistMenuClose"
                                    }
                                  ],
                                  ref: "taskListMenus",
                                  staticClass: "operate-menu",
                                  style: { top: _vm.taskListMenuTop + "Px" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "operate-menu-item",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.viewLogsOpen(_vm.item)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "icon-util remote-task operate-icon-position"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "operate-menu-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "language.popup.taskListPopup.viewLogs"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.item.type == 6
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "operate-menu-item",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openBackupRestore()
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "icon-util backup-restore-icon operate-icon-position"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "operate-menu-name"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.cloudExploer.restore"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.item.type == 6
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "operate-menu-item",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openVersions()
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "icon-util backup-version-icon operate-icon-position"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "operate-menu-name"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.cloudBackup.versions"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "operate-menu-item",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.openOptionsDialog(
                                            _vm.item,
                                            _vm.index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "icon-util properties operate-icon-position"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "operate-menu-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.common.options")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.item.branchType != "realtime"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "operate-menu-item",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.openSchduleDialog(
                                                _vm.item,
                                                _vm.index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "icon-util  operate-icon-position",
                                            class:
                                              _vm.item.type == 6
                                                ? "schedule-backup-icon"
                                                : "schedule"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "operate-menu-name"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.common.schedule"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "operate-menu-item",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteTaskItem(
                                            _vm.item,
                                            _vm.index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "icon-util delete operate-icon-position"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "operate-menu-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.common.delete")
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCollPage(_vm.item)
                    ? _c("div", {
                        staticClass: "icon-util  task-operating-menu",
                        class: [
                          _vm.showSourceCollPageUp(_vm.item, _vm.index)
                            ? "task-list-operating-up"
                            : "task-list-operating-down",
                          _vm.item.cancelingShow ? "task-list-cancel-down" : ""
                        ],
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.collapsePage(_vm.index, _vm.item)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.item.cancelingShow,
                          expression: "item.cancelingShow"
                        }
                      ],
                      class: [
                        _vm.item.updateFlag
                          ? "transfers-button-update"
                          : "transfers-button",
                        _vm.eidtTaskFlag ? "oprate-not-allowed" : "",
                        _vm.item.cancelingShow ? "canceling item-onlyRead" : ""
                      ],
                      attrs: { id: "canceling", disabled: _vm.eidtTaskFlag },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.clickButton(_vm.item, _vm.index)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.buttonTxt) + "\n          ")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "transfers-status" }, [
              _c("div", { staticClass: "status-txt" }, [
                _vm.iconName
                  ? _c("div", {
                      staticClass: "icon-util tasks-icon-position",
                      class: _vm.iconName
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.branchType == "realtime" &&
                (_vm.item.status == "Run" || _vm.item.status == "Init")
                  ? _c("div", {
                      staticClass:
                        "realtimetasks-run Rotation tasks-icon-position  task-run-position"
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.branchType == "realtime" &&
                (_vm.item.status == "Stop" ||
                  _vm.item.status == "InitStop" ||
                  _vm.item.status == "TimeoutStop")
                  ? _c("div", {
                      staticClass:
                        "icon-paused tasks-icon-position realtime-position"
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.type == 2 && _vm.item.sources && _vm.item.avgpercent
                  ? _c("span", [
                      _c(
                        "span",
                        {
                          class:
                            _vm.item.branchType != "realtime" &&
                            (_vm.iconName || _vm.item.viewed)
                              ? "operation-result"
                              : "",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.viewLogs()
                            }
                          }
                        },
                        [
                          _vm.$i18n.locale == "deutsch" && _vm.item.avgpercent
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.item.avgpercent) + "%")
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("language.common.syncing")) +
                              "...\n              "
                          ),
                          _vm.$i18n.locale != "deutsch" && _vm.item.avgpercent
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.item.avgpercent) + "%")
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  : _c(
                      "span",
                      {
                        class:
                          _vm.item.branchType != "realtime" &&
                          (_vm.iconName || _vm.item.viewed)
                            ? "operation-result"
                            : "",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.viewLogs()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.statusTxt))]
                    )
              ])
            ]),
            _vm._v(" "),
            _vm.item.status == "TimeoutStop"
              ? _c(
                  "div",
                  {
                    staticClass: "traverse-time-out",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.traverseOpen()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("language.cloudSync.timeOut")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("viewLogsDialog", { ref: "viewLogsDialog" }),
      _vm._v(" "),
      _c("transferOptionsDialog", { ref: "transferOptionsDialog" }),
      _vm._v(" "),
      _c("emailTransferOptionsDialog", { ref: "emailTransferOptionsDialog" }),
      _vm._v(" "),
      _c("syncOptionsDialog", { ref: "syncOptionsDialog" }),
      _vm._v(" "),
      _c("transferScheduleDialog", { ref: "transferScheduleDialog" }),
      _vm._v(" "),
      _c("viewRealTimeLogsDialog", { ref: "viewRealTimeLogsDialog" }),
      _vm._v(" "),
      _c("viewBackupLogsDialog", { ref: "viewBackupLogsDialog" }),
      _vm._v(" "),
      _c("failedFilesDialog", { ref: "failedFilesDialog" }),
      _vm._v(" "),
      _c("backupOptionDialog", { ref: "backupOptionDialog" }),
      _vm._v(" "),
      _c("backupRestoreDialog", { ref: "backupRestoreDialog" }),
      _vm._v(" "),
      _c("versionsDialog", { ref: "versionsDialog" }),
      _vm._v(" "),
      _c("deleteAttentionDialog", { ref: "deleteAttentionDialog" }),
      _vm._v(" "),
      _c("traveseDialog", { ref: "traveseDialog" }),
      _vm._v(" "),
      _c("noticeDialog", { ref: "noticeDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-181dbcf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181dbcf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_single_task.vue
// module id = null
// module chunks = 